<script lang="ts">
  import { _ } from "svelte-i18n";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Price from "$lib/components/Price/Price.svelte";
  import { createEventDispatcher } from "svelte";
  import Quantity from "$lib/components/ProductDetail/Quantity/Quantity.svelte";
  import { linkTo } from "$lib/utils/url";
  import type { CartLine } from "$lib/gql/gen/codegen";
  import Picture from "../Picture/Picture.svelte";

  export let item: CartLine;

  $: item = item;

  const canonicalUrl = item?.merchandise?.product?.canonicalUrl?.value;
  const itemUrlAttribute = item?.attributes?.find(
    attribute => attribute.key === "_url",
  );
  const itemUrl = itemUrlAttribute?.value || "bag";

  const title = item?.merchandise?.product.title;
  const url = canonicalUrl ? canonicalUrl : itemUrl;
  const imageSrc = item?.merchandise?.image.url;
  const variants = item?.merchandise?.selectedOptions;
  const price = item?.merchandise?.price;
  const compareAtPrice = item?.merchandise?.compareAtPrice;
  const quantityAvailable = item?.merchandise?.quantityAvailable;
  let quantity = item?.quantity;

  const giftCard = item?.merchandise?.sku.includes("GIFT CARD");

  const attributes = item?.attributes
    .filter(attribute => attribute.key !== "_url")
    .filter(
      attribute => attribute.key !== "__shopify_send_gift_card_to_recipient",
    )
    .filter(attribute => attribute.value !== "");

  const imageConfig = {
    smSize: {
      width: 76,
      height: 95,
    },
    mdSize: {
      width: 76,
      height: 95,
    },
    lgSize: {
      width: 76,
      height: 95,
    },
    xlSize: {
      width: 76,
      height: 95,
    },
  };

  const dispatch = createEventDispatcher();

  const onClick = () => {
    //dispatch selected item for GTM `select_item` event
    dispatch("itemSelection", item);
  };
</script>

<style lang="scss">
  .basket-item {
    display: flex;
    padding-bottom: 2rem;
    &--img {
      height: 100%;
      width: 100%;
      max-height: 10rem;
      max-width: 8rem;
      position: relative;
      border: none !important;
    }
    &--info {
      padding-left: 8px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 24px;
    }
    &--top {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      &__title {
        margin-bottom: 16px;
        text-transform: capitalize;
        max-width: 311px;
        margin-bottom: 0;
      }
    }
    &--bottom {
      display: flex;
      justify-content: space-between;
      &--details {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }

      &--price {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }

      &__meta {
        display: flex;
        flex-direction: column;
        &--entry {
          text-transform: capitalize;
        }
        &--entry-alt {
          padding-bottom: 1px;
        }
      }
    }
  }
</style>

<div class="basket-item">
  {#if imageSrc}
    <a href={linkTo(url)} class="basket-item--img" on:click={onClick}>
      <Picture
        altText={title}
        {imageConfig}
        smImage={imageSrc}
        mdImage={imageSrc}
        shopifyImage
      />
    </a>
  {/if}

  <div class="basket-item--info">
    <div class="basket-item--top">
      <div class="basket-item--top__title">
        <Typography component="h3" variant="h3-1">
          {title?.toLowerCase()}
        </Typography>
      </div>
    </div>
    <div class="basket-item--bottom">
      <div class="basket-item--bottom--details">
        <div>
          <div class="basket-item--bottom__meta">
            {#each variants as variant}
              <div class="basket-item--bottom__meta--entry">
                <Typography component="span" variant="caption2">
                  {$_(variant?.name)}:
                </Typography>
                <Typography component="span" variant="caption2">
                  {variant?.value}
                </Typography>
              </div>
            {/each}

            {#if giftCard}
              <div>
                {#each attributes as variant}
                  <div class="basket-item--bottom__meta--entry-alt">
                    <Typography component="span" variant="caption2">
                      {$_(variant.key)}:
                    </Typography>
                    <Typography component="span" variant="caption2">
                      {variant.value}
                    </Typography>
                  </div>
                {/each}
              </div>
            {/if}
          </div>
        </div>
      </div>

      <div class="basket-item--bottom--price">
        <div class="basket-item-top__price">
          <Price
            variant="caption2"
            variantPrice={price}
            variantComparePrice={compareAtPrice ? compareAtPrice : undefined}
          />
        </div>
      </div>
    </div>
    <Quantity
      on:change
      bind:quantity
      totalInventory={quantityAvailable ? quantityAvailable : NaN}
    />
  </div>
</div>
